// extracted by mini-css-extract-plugin
export default {"title":"custom-modal_title__XT4Nf","btn":"custom-modal_btn__QnJIp","delimiter":"custom-modal_delimiter__amuZt"};